export const config = {
  // Empty string = same origin. Vite dev server proxies /api and /health to :4000.
  // In production set VITE_API_URL to the deployed API endpoint if the web is
  // hosted separately; leave blank if served from the same origin.
  apiUrl: import.meta.env.VITE_API_URL ?? '',
};
